import { Navigate } from 'react-router';
import { useAuth } from '../auth/AuthProvider';
import type { AdminPage } from './adminPages';
import { ForbiddenPage } from './ForbiddenPage';

/** `/admin`: 最初に権限のある管理ページへ。ひとつも無ければ権限なしページ。 */
export const AdminIndex = ({ pages }: { pages: readonly AdminPage[] }) => {
  const { can } = useAuth();
  const first = pages.find((page) => can(page.permission));
  return first === undefined ? <ForbiddenPage /> : <Navigate to={`/admin/${first.path}`} replace />;
};
